import React from 'react';
import moment from 'moment';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { joinDefined, prettyPhone } from './strings';


// when using this make sure u add onClickViewAppointment() funciton in the component to enable editing
export const appointmentColumns = [
    {
        label: 'Reason',
        renderCell: row => {
            return <span>{row.Reason}</span>;
        }
    },
    {
        label: 'Date/Time',
        renderCell: row => <span>{moment(row.Date + 'T' + row.TimeFrom).format('ddd Do MMM Y [from] LT')}</span>
    },
    {
        label: 'Staff',
        renderCell: row => row.Members.map((user, idx) => (
                <span key={user.ID}>
                    {!!idx && ', '}
                    {joinDefined([user.FirstName, user.Surname], ' ')}
                </span>
            )
        )
    },
    {
        label: 'Location',
        renderCell: x => (
            <span>
                {x.LocationType === 'AddressBook'
                    ? !!x.LocationCM &&
                    x.LocationCM.Name +
                    ' - ' +
                    joinDefined([x.LocationCM.AddressLine1, x.LocationCM.AddressLine2, x.LocationCM.Suburb], ', ')
                    : (!!x.LocationResidentialAddress &&
                        joinDefined(
                            [
                                x.LocationResidentialAddress.AddressLine1,
                                x.LocationResidentialAddress.AddressLine2,
                                x.LocationResidentialAddress.Suburb,
                                x.LocationResidentialAddress.Country === 'Australia'
                                    ? x.LocationResidentialAddress.State
                                    : x.LocationResidentialAddress.Country
                            ],
                            ', '
                        )) ||
                    (x.Phone && <span>Phone: {prettyPhone(x.Phone)}</span>)}
            </span>
        )
    },
    {
        label: '',
        renderCell: (row, context) => {
            if (!context || typeof context.onClickViewAppointment !== 'function') {
                return null;
            }
            return (
                <IconButton className="icon" onClick={() => context.onClickViewAppointment(row.ID)} size="large">
                    <EditIcon />
                </IconButton>
            );
        }
    }
];
